import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

export default function save({ attributes }) {
	const { blockId, title } = attributes;
	const randomId = blockId;

	const blockProps = useBlockProps.save({
		className: 'bem-ipmcollapseblock--accordion wp-block-ipm-collapseblock accordion accordion-flus',
		id: 'accordion-ipm-category-' + randomId,
	});

	return (
		<div {...blockProps}>
			<div className="bem-ipmcollapseblock--item accordion-item">
				<h2 className="accordion-header" id={'heading-' + randomId}>
					<button
						className="bem-ipmcollapseblock--header accordion-button collapsed"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target={'#collapse-' + randomId}
						aria-expanded="false"
						aria-controls={'collapse-' + randomId}
					>
						{title}
					</button>
				</h2>
				<div
					className="bem-ipmcollapseblock--collapse accordion-collapse collapse"
					id={'collapse-' + randomId}
					aria-labelledby={'heading-' + randomId}
					data-bs-parent={'#accordion-ipm-category-' + randomId}
				>
					<div className="bem-ipmcollapseblock--body accordion-body d-flex">
						<InnerBlocks.Content />
					</div>
				</div>
			</div>
		</div>
	);
}
